"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
var _filterFields = _interopRequireDefault(require("../filterFields.js"));
var _widgets = _interopRequireDefault(require("../widgets.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var initialValues = exports.initialValues = {
  filterFields: _filterFields["default"].map(function (item) {
    return item.name;
  }),
  otherFilterOptions: [],
  colors: {
    primary: '#3673b6'
  },
  header: {
    title: 'Group Session Log Report',
    subtitle: 'Tracks the degree to which the program is delivered as intended',
    groupLeaderText: 'Group Leader Name:',
    reportingPeriodText: 'Reporting Period:',
    createdDateText: 'Report Created On:',
    description: 'The Log Report compiles and summaries session notes and data collected on each participant in a group across all sessions in the program.',
    numGroupsText: 'Number of groups included:',
    numParticipantsText: 'Number of individuals included:'
  },
  body: {
    heading: '<p><span style="font-size: 1.2em;">Ratios for each component are presented as the number of "yes" responses selected out of the total possible number.</span></p>'
  },
  widgets: _widgets["default"].reduce(function (obj, w) {
    obj[w.handle] = w.builderInitialValues;
    return obj;
  }, {})
};
var Component = function Component(props) {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelAppdefs.BuilderBlock, {
    title: "Header"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "header.title",
    component: _cccisdFormik.CccisdInput,
    label: "Title"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "header.subtitle",
    component: _cccisdFormik.CccisdInput,
    label: "Subtitle"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "header.description",
    component: _cccisdFormik.CccisdInput,
    label: "Description"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "header.reportingPeriodText",
    component: _cccisdFormik.CccisdInput,
    label: "Reporting Period Text"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "header.createdDateText",
    component: _cccisdFormik.CccisdInput,
    label: "Created Date Text"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelAppdefs.BuilderBlock, {
    title: "Subheader"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "header.groupLeaderText",
    component: _cccisdFormik.CccisdInput,
    label: "Group Leader Text"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "header.numGroupsText",
    component: _cccisdFormik.CccisdInput,
    label: "Number of Groups Text"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "header.numParticipantsText",
    component: _cccisdFormik.CccisdInput,
    label: "Number of Individuals Text"
  }))), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelAppdefs.BuilderBlock, {
    title: "Body"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "body.heading",
    component: _cccisdFormik.CccisdWysiwyg,
    label: "Page Heading"
  })), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelAppdefs.BuilderBlock, {
    title: "Color"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '230px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "colors.primary",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Color Scheme"
  }))));
};
Component.propTypes = {
  onValidChange: _propTypes["default"].func,
  settings: _propTypes["default"].object
};
var _default = exports["default"] = (0, _cccisdLaravelAppdefs.reportTemplateBuilder)({
  filterFields: _filterFields["default"],
  widgets: _widgets["default"]
})(Component);